import React from 'react';
import UserPageShell from '../shared/UserPageShell';
import UserStaffManager from '../shared/UserStaffManager';

const UserStaff: React.FC = () => (
  <UserPageShell enter>
    <UserStaffManager />
  </UserPageShell>
);

export default UserStaff;
